import { render } from "./doctor-awards-settings.vue?vue&type=template&id=02798f73"
import script from "./doctor-awards-settings.vue?vue&type=script&lang=js"
export * from "./doctor-awards-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__